let { View, Utils } = window.App;

import 'owl.carousel';

const SELECTOR = '.js-autoscroll-slider';

class AutoscrollSlider{
    constructor( el ){
        this.el = el;
        this.$el = $( el );
        this.$holder = this.$el.find( SELECTOR + '__holder' );
        this.$slider = this.$el.find( SELECTOR + '__slider' );
        this.$header = $( '.js-header' );

        this.$slider.addClass( 'owl-carousel' ).owlCarousel( this.getOptions() );

        this.$items = this.$slider.find( '.owl-item:not( .cloned )' );

        this.state = 'waiting';
        this.holder_height = 0;
        this.holder_width = 0;
        this.holder_offset = { top: 0, left: 0 };
        this.el_offset = { top: 0, left: 0 };
        this.el_height = 0;
        this.window_height = window.App.$window.height();
        this.window_width = window.App.$window.width();

        this.$slider.on( {
            'resized.owl.carousel': $.proxy( this.calcHeight, this ),
            'changed.owl.carousel': $.proxy( this.onSliderChanged, this ),
        } );
        window.App.$window.on( {
            resize: $.proxy( this.calcWindowPositions, this ),
            scroll: $.proxy( this.checkScrollPosition, this ),
        } );

        this.calcHeight();
        this.calcWindowPositions();
    }

    getOptions(){
        return {
            items     : 1,
            autoHeight: false,
            loop      : false,
            nav       : true,
            dots      : true,
            navText   : [ Utils.icon( 'arrow-left' ), Utils.icon( 'arrow-right' ) ],
        };
    }

    calcHeight(){
        this.resetHolder();

        this.$el.css( 'position', 'relative' );

        this.holder_height = this.$holder.outerHeight();
        this.holder_width = this.$holder.width();
        this.holder_offset = this.$holder.offset();
        this.el_offset = this.$el.offset();
        this.el_height = this.holder_height * this.$items.length;

        this.$el.height( this.el_height );

        this.checkScrollPosition();
    }

    calcWindowPositions(){
        this.resetHolder();

        this.window_height = window.App.$window.height();
        this.window_width = window.App.$window.width();
        this.el_offset = this.$el.offset();

        this.checkScrollPosition();
    }

    checkScrollPosition(){
        let scroll_top = window.App.$window.scrollTop();
        let header_height = this.$header.outerHeight();

        if( scroll_top >= this.el_offset.top - ( this.window_height + header_height ) / 2 + ( this.holder_height / 2 ) ){
            if( scroll_top <= this.el_offset.top + this.el_height - ( this.window_height + header_height ) / 2 - ( this.holder_height / 2 ) ){
                this.$holder.css( {
                    position: 'fixed',
                    top     : ( this.window_height + header_height ) / 2 - ( this.holder_height / 2 ),
                    width   : this.$el.width(),
                } );
            }else{
                this.$holder.css( {
                    position: 'relative',
                    top     : this.el_height - this.holder_height,
                    width   : '',
                } );
            }
        }else{
            this.resetHolder();
        }

        if( this.state != 'scrolling' ){
            let pos = scroll_top + this.window_height / 2 - this.el_offset.top;
            let pos_percent = pos / this.el_height;
            let slide_percent = 1 / this.$items.length;
            let slide = Math.floor( pos_percent / slide_percent );

            slide = Math.min( slide, this.$items.length - 1 );
            slide = Math.max( slide, 0 );

            if( this.$items.index( this.$items.filter( '.active' ) ) != slide ){
                this.state = 'checking';
                this.$slider.trigger( 'to.owl.carousel', slide );
                this.state = 'waiting';
            }
        }
    }

    onSliderChanged( e ){
        if( this.state == 'checking' ){
            return;
        }

        let header_height = this.$header.outerHeight();
        this.state = 'scrolling';
        let percent = e.item.index / e.item.count;
        let half_slide_percent = 1 / e.item.count / 2;
        let scroll_pos_percent = percent + half_slide_percent;
        let scroll_pos = this.el_offset.top + ( this.el_height * scroll_pos_percent ) - ( this.window_height + header_height ) / 2;

        window.App.$bodyHtml.animate( { scrollTop: scroll_pos }, 300, _ => this.state = 'waiting' );
    }

    resetHolder(){
        this.$holder.removeAttr( 'style' );
    }
}

View.addHook( 'init', v => {
    v.$( SELECTOR ).each( function(){
        new AutoscrollSlider( this );
    } );
} );



// WEBPACK FOOTER //
// ./resources/js/modules/autoscroll-slider.js